/*
 *   File : order-detail.js
 *   Author : https://evoqins.com
 *   Description : Order detail page
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';

// custom components
import { StatisticCard } from '../../Components/Card';
import { TextButton } from '../../Components/Buttons';
import { Chip } from '../../Components/Others';
import { CustomDataTable } from '../../Components/DataTable';
import { OrderTimelineModal } from '../../Components/Modal';
import { APIService } from '../../Service';

// custom styles
import style from "../../Style/Component/order.module.scss";


const OrderDetail = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const { state } = useLocation();

    const isRendered = useRef(true);


    const [currentPage, setCurrentPage] = useState(1);
    const [timelineModal, setTimelineModal] = useState(false);
    const [orderDetailData, setOrderDetailData] = useState({});
    const [timeLineData, setTimeLineData] = useState(null);

    const [loader, setLoader] = useState(true);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        if (isRendered.current === true) {
            _orderDetail();
        }
        isRendered.current = false;
    }, [isRendered]);

    useEffect(() => {
        if (timelineModal === true) {
            const timeline_modal = new Modal(document.getElementById('timeline-modal'));
            timeline_modal.show();
        }
    }, [timelineModal]);

    // handle view time line 
    const _handleViewTimeLine = (order_id) => {
        setTimeLineData(order_id)
        setTimelineModal(true);
    };

    // handle table page change 
    const _handleTablePageChange = (page_num) => {
        setCurrentPage(page_num);
    };

    // Pending request data table column 
    const ORDER_TABLE_COLUMN = [
        {
            name: 'Funds',
            cell: (row) =>
                <div className='d-flex align-items-center gap-2'>
                    <div className={`${style.e_fund_img_wrapper} e-bg-white padding-2px-all border-radius-4`}>
                        <img src={row.image}
                            draggable={false}
                            width={20}
                            height={20}
                            alt='fund'
                            className='object-fit-contain'
                            onClick={() => _handleViewTimeLine(row)} />
                    </div>
                    <p className='mb-0'
                        onClick={() => _handleViewTimeLine(row)}
                    >
                        {row.mutual_fund}
                    </p>
                </div>
            ,
            width: "360px"
        },
        {
            name: "FP Purchase ID",
            selector: row => row.fp_order_id ? row.fp_order_id : "-",
            width: "360px",
        },
        {
            name: 'Amount',
            selector: row => row.amount,
            width: "150px"
        },
        {
            name: 'Unit',
            selector: row => row.units || '-',
            width: "140px"
        },
        {
            name: 'NAV',
            selector: row => row.allocated_nav || '-',
            width: "140px"
        },
        {
            name: 'Allocated date',
            selector: row => row.allocated_date || '-',
            width: "160px"
        },
        {
            name: 'Folio no',
            selector: row => row.folio_number || '-',
            width: "190px"
        },
        {
            name: '',
            cell: (row) =>
                <TextButton name='View detail'
                    className='e-hover'
                    onClick={() => _handleViewTimeLine(row)} />,
            width: "150px"
        },
    ];


    const _orderDetail = () => {
        let is_post = true;
        let url = 'orders/detail';
        let request = {
            "order_id": id
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setOrderDetailData(response.data);
                setLoader(false);

            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
                // navigate("/orders");

                setTimeout(() => {
                    navigate(-1);
                }, 1000);
            }
        })
    };


    // handle previous page
    const _handleBack = () => {
        if (state !== null) {
            // navigate("/orders", {
            //     state: {
            //         tab_index: state.tab_index,
            //         current_page: state.current_page
            //     }
            // });

            navigate(-1);
        } else {
            navigate("/orders", {
                state: {
                    tab_index: 1,
                    current_page: 1
                }
            });
        }
    };

    return (
        <Fragment>
            <section className='e-section-height pb-5' >
                {loader ?
                    <div className='d-flex align-items-center justify-content-center pt-4'>
                        <img src={require("../../Assets/Image/loader.gif")}
                            draggable={false}
                            alt='loader'
                            width={80}
                            height={80}
                            className='text-center' />
                    </div>
                    :
                    <>
                        <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                                <span className='text-decoration-hover-underline cursor-pointer'
                                    onClick={() => _handleBack()}>Orders</span> / <span className='e-font-weight-600'>{orderDetailData?.summary?.display_order_id}</span>
                            </p>
                        </div>

                        <div className='padding-52px-lr margin--80px-top'>

                            {/* Order summary */}

                            <div className={`${style.e_order_summary_wrapper} e-bg-american-violet border-radius-16 padding-32px-all`}>
                                <div className='d-flex align-items-center gap-12px '>
                                    <div className={`${style.e_order_icon_wrapper} border-radius-8 e-bg-white py-2 padding-12px-lr w-max-content`}>
                                        <img src={orderDetailData.summary.icon}
                                            draggable={false}
                                            width={20}
                                            className='object-fit-contain'
                                            height={26}
                                            alt='order-icon' />
                                    </div>
                                    <h4 className='mb-0 e-text-white e-primary-font e-font-20 e-font-weight-600 line-height-24px'>
                                        {orderDetailData.summary.order_name}
                                    </h4>
                                </div>

                                {/* Statistic cards */}
                                <div className='row row-cols-6 row-gap-4 pt-4 mt-2'>
                                    <div className='col'>
                                        <StatisticCard title="Order ID"
                                            value={orderDetailData.summary.display_order_id} />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="Executed on"
                                            value={orderDetailData.summary.created_on} />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="Amount invested"
                                            value={orderDetailData.summary.total_amount} />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="Type"
                                            value={orderDetailData.summary.type} />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="Order status"
                                            value={
                                                <Chip label={orderDetailData.summary.order_status}
                                                    textAlign={"justify-content-start"}
                                                    // className="e-bg-green-crayola padding-2px-tb"
                                                    className={orderDetailData.summary.order_status.toLowerCase() === "successful" ? "e-bg-green-crayola padding-2px-tb" :
                                                        orderDetailData.summary.order_status.toLowerCase()  === "failed" ? "e-bg-maximum-red padding-2px-tb" :
                                                            orderDetailData.summary.order_status.toLowerCase()  === "pending" ? "e-bg-marigold padding-2px-tb" : "padding-2px-tb e-bg-bleu-de-france"} />
                                            } />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="Payment status"
                                            value={
                                                <Chip label={orderDetailData.summary.payment_status}
                                                    textAlign={"justify-content-start"}
                                                    className={orderDetailData.summary.payment_status === "Success" ? "e-bg-green-crayola" :
                                                        orderDetailData.summary.payment_status === "Failed" ? "e-bg-maximum-red " :
                                                            orderDetailData.summary.payment_status === "Pending" ? "e-bg-marigold" : "e-bg-bleu-de-france"} />
                                            } />
                                    </div>
                                </div>
                            </div>


                            {/* Order details */}
                            <div className={`${style.e_order_detail_table_wrapper} e-bg-ghost-white border-radius-16 margin-32px-top`}>
                                <div className='padding-32px-lr padding-32px-top'>
                                    <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                        Order details
                                    </h4>
                                </div>
                                {/* Order list table */}

                                <div className='e-data-table-wrapper pt-4 pb-4'>
                                    <CustomDataTable columns={ORDER_TABLE_COLUMN}
                                        data={orderDetailData.order_details}
                                        pagination={false}
                                        // paginationPerPage={10}
                                        // paginationTotalRows={ORDER_DATA.length}
                                        onChangePage={_handleTablePageChange}
                                        rowClick={_handleViewTimeLine} />
                                </div>

                            </div>
                        </div>
                    </>
                }
            </section>


            {/* Order timeline modal */}
            {timelineModal === true &&
                <OrderTimelineModal
                    timelineData={timeLineData}
                    handleClose={() => setTimelineModal(false)} />
            }
        </Fragment>
    )
}

export default OrderDetail;
